import Identity from './Identity';
import {Entity} from './Entity';
import {Value} from './Value';

export class Relation<ID extends Identity, T extends Record<string, Value<any>>> extends Entity<ID, T> {

}